import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=56e3c0b4&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=56e3c0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3c0b4",
  null
  
)

export default component.exports